module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "header"
  }, [(!_vm.schoolLock) ? _c('div', {
    staticClass: "choose-school",
    on: {
      "click": _vm.chooseSchool
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]) : _c('div', {
    staticClass: "choose-school no-choose"
  }, [_c('span', [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]), _vm._v(" "), _c('div', {
    staticClass: "to-search",
    on: {
      "click": _vm.toSearch
    }
  }, [_c('span', [_vm._v("搜索商家、商品名称")])])]), _vm._v(" "), _c('div', {
    staticClass: "main no-foot"
  }, [_c('div', {
    staticClass: "banner",
    attrs: {
      "id": "banner1"
    }
  }, [(_vm.banners.length > 0) ? _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + item.imageUrl + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.bannerJump(item.data)
        }
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })]), _vm._v(" "), (_vm.showPage) ? _c('div', [(_vm.shopCategoryList.length > 0) ? _c('div', {
    staticClass: "category-list"
  }, [_c('ul', _vm._l((_vm.shopCategoryList), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toShopList(item.id, item.category_name)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: (item.backgroundimg)
    }), _vm._v(_vm._s(item.category_name) + "\n            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goods-list shop"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("本校商家")]), _vm._v(" "), _c('ul', _vm._l((_vm.currentShopList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des"
    }, [_c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "threshold"
    }, [_c('span', [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), (item.delivery_type == 0) ? _c('span', [_vm._v("配送 ￥" + _vm._s(item.delivery_fee))]) : _c('span', [_vm._v("配送 ￥" + _vm._s(item.delivery_fee) + " (商家自配送)")])]), _vm._v(" "), (item.promotion_list.length > 0) ? _c('div', [(item.promotion_list.length <= 2) ? _c('div', {
      staticClass: "more-promotion"
    }, _vm._l((item.promotion_list), function(p) {
      return _c('div', {
        staticClass: "des"
      }, [_c('span', {
        style: ({
          backgroundImage: 'url(' + p.icon_url + ')'
        })
      }, [_vm._v(_vm._s(p.promotion_name))])])
    }), 0) : _c('div', {
      staticClass: "more-promotion"
    }, [(item.isShowAll) ? _c('div', [_vm._l((item.promotion_list), function(p) {
      return _c('div', {
        staticClass: "des"
      }, [_c('span', {
        style: ({
          backgroundImage: 'url(' + p.icon_url + ')'
        })
      }, [_vm._v(_vm._s(p.promotion_name))])])
    }), _vm._v(" "), _c('span', {
      staticClass: "shield-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    })], 2) : _c('div', [_c('div', {
      staticClass: "des"
    }, [_c('span', {
      style: ({
        backgroundImage: 'url(' + item.promotion_list[0].icon_url + ')'
      })
    }, [_vm._v(_vm._s(item.promotion_list[0].promotion_name))])]), _vm._v(" "), _c('div', {
      staticClass: "des"
    }, [_c('span', {
      style: ({
        backgroundImage: 'url(' + item.promotion_list[1].icon_url + ')'
      })
    }, [_vm._v(_vm._s(item.promotion_list[1].promotion_name))])]), _vm._v(" "), _c('span', {
      staticClass: "show-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    })])])]) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("休息中")])])])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-56f2bf28","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomePage.vue
// module id = 441
// module chunks = 7